// extracted by mini-css-extract-plugin
export default {"shift_list":"JDList_shift_list__h0-y-","date_title":"JDList_date_title__cRkuv","spin":"JDList_spin__zCS7t","fadeInDown":"JDList_fadeInDown__aDo0q"};